import { render } from "./DialogTwoColFullscreen.vue?vue&type=template&id=572202b1&scoped=true"
import script from "./DialogTwoColFullscreen.vue?vue&type=script&lang=js"
export * from "./DialogTwoColFullscreen.vue?vue&type=script&lang=js"

import "./DialogTwoColFullscreen.vue?vue&type=style&index=0&id=572202b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572202b1"]])

export default __exports__